import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 0 24px 136px;
  max-width: 448px;
`;

export const InputWrapper = styled.div`
  max-width: 400px;
`;
